import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { GeoLearnMoreModal } from "./GeoLearnMoreModal";

const STORAGE_KEY = "geo-banner-dismissed";

export function GeoBanner() {
  const [isDismissed, setIsDismissed] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY) === "true";
    setIsDismissed(dismissed);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setIsDismissed(true);
  };

  if (isDismissed) return null;

  return (
    <>
      <div className="w-full bg-gradient-to-r from-primary/15 via-primary/10 to-accent/15 border-b border-primary/20">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-4">
            <p className="text-sm font-medium text-foreground flex-1">
              🚀 <span className="font-bold">New:</span> Discover prompts by intent, use-case, and trust — powered by GEO.
            </p>
            
            <div className="flex items-center gap-2">
              <Button
                variant="link"
                size="sm"
                className="text-primary font-medium h-auto p-0"
                onClick={() => setIsModalOpen(true)}
              >
                Learn More
              </Button>
              
              <Button
                variant="ghost"
                size="sm"
                className="h-6 w-6 p-0 text-muted-foreground hover:text-foreground"
                onClick={handleDismiss}
                aria-label="Dismiss banner"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      <GeoLearnMoreModal open={isModalOpen} onOpenChange={setIsModalOpen} />
    </>
  );
}
